import React from 'react';
import { Modal, View, Pressable, Platform } from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import * as Animatable from 'react-native-animatable';
import ComingSoon from './ComingSoon';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import styles from '@stylesheet';
import CloseButton from '@components/UI/CloseButton';

interface ComingSoonModalProps {
  visible: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  message?: string;
  showAnimation?: boolean;
  animationSource?: any;
  closeOnBackdrop?: boolean;
  showCloseButton?: boolean;
}

const ComingSoonModal: React.FC<ComingSoonModalProps> = ({
  visible,
  onClose,
  title,
  subtitle,
  message,
  showAnimation = true,
  animationSource,
  closeOnBackdrop = true,
  showCloseButton = true,
}) => {
  const theme = themeSelector();

  const handleBackdropPress = () => {
    if (closeOnBackdrop) {
      onClose();
    }
  };

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      statusBarTranslucent={Platform.OS === 'android'}
      onRequestClose={onClose}
    >
      <View style={[
        styles.comingSoonModalOverlay,
        { backgroundColor: 'rgba(0,0,0,0.7)' }
      ]}>
        <Pressable 
          style={styles.comingSoonModalBackdrop}
          onPress={handleBackdropPress}
        >
          <Animatable.View
            animation="zoomIn"
            duration={300}
            easing="ease-out"
            style={styles.comingSoonModalWrapper}
          >
            <Pressable onPress={() => {}} style={styles.comingSoonModalContent}>
              {showCloseButton && (
                <CloseButton handleClose={onClose}  />
              )}

              <ComingSoon
                title={title}
                subtitle={subtitle}
                message={message}
                showAnimation={showAnimation}
                animationSource={animationSource}
                containerStyle={[
                  styles.comingSoonModalInnerContainer,
                  { backgroundColor: 'transparent' }
                ]}
              />
            </Pressable>
          </Animatable.View>
        </Pressable>
      </View>
    </Modal>
  );
};

export default ComingSoonModal;
